import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	'components': {
		'app': {},
	},
	'theme': {
		'base': {
			'card': {
				'children': {
					'subtitle': {
						'breakpoints': [
							{
								'max': '767px',
								'style': {
									'margin': {
										'bottom': '8px',
										'top': '8px',
									},
								},
							},
						],
						'color': '#5f5f5f',
						'font': {
							'family': 'Heebo, sans-serif',
							'size': '16px',
							'style': 'normal',
							'weight': '400',
						},
						'lineHeight': '24px',
						'margin': {
							'bottom': '16px',
							'top': '0px',
						},
					},
					'title': {
						'font': {
							'family': 'Heebo, sans-serif',
							'size': '24px',
							'weight': '400',
						},
						'margin': {
							'bottom': '32px',
						},
					},
					'wrapper': {
						'breakpoints': [
							{
								'max': '1023px',
								'min': '320px',
								'style': {
									'margin': {
										'top': '0px',
									},
								},
							},
						],
						'margin': {},
						'overrides': [
							{
								'selector': '[data-selector="overview-disclaimer-text"]',
								'style': {
									'color': '#001928',
									'font': {
										'family': 'Heebo, Arial, sans-serif',
										'size': '13px',
										'weight': '400',
									},
									'lineHeight': '19px',
									'overrides': [
										{
											'selector': 'p',
											'style': {
												'color': '#001928',
												'font': {
													'family': 'Heebo, Arial, sans-serif',
													'size': '13px',
													'weight': '400',
												},
												'lineHeight': '19px',
											},
										},
									],
								},
							},
						],
					},
				},
			},
			'heading': {
				'children': {
					'h3': {
						'breakpoints': [
							{
								'max': '767px',
								'style': {
									'margin': {
										'bottom': '8px',
									},
								},
							},
						],
						'margin': {
							'bottom': '16px',
							'top': '0px',
						},
					},
				},
				'overrides': [
					{
						'selector': 'h2',
						'style': {
							'color': '#001928',
							'font': {
								'family': '\'Heebo\', sans-serif',
								'size': '24px',
								'style': 'normal',
								'weight': '400',
							},
							'lineHeight': '29px',
						},
					},
				],
			},
			'list': {
				'children': {
					'lastContent': {
						'font': {
							'weight': '400',
						},
					},
					'listItemWrapper': {
						'color': '#001928',
						'font': {
							'family': '\'Heebo\', Sans-serif',
							'size': '14px',
							'style': 'normal',
							'weight': '500',
						},
						'lineHeight': '16px',
						'selectors': [
							{
								':first-child': {
									'background': {
										'color': '#0075BE',
									},
									'color': '#fff',
									'overrides': [
										{
											'selector': '[data-selector="base-list-multipartListItem"]',
											'style': {
												'flex': {
													'direction': 'row',
												},
												'font': {
													'family': '\'Heebo Medium\', sans-serif',
												},
											},
										},
									],
								},
							},
							{
								':nth-child(even)': {
									'background': {
										'color': '#F5F6F7',
									},
								},
							},
						],
					},
					'multipartListItem': {
						'align': {
							'items': 'center',
						},
						'border': {
							'bottom': {
								'_value': '1px solid rgb(199, 199, 199)',
							},
						},
						'display': 'flex',
						'justifyContent': 'space-between',
						'min': {
							'height': '55px',
						},
						'padding': {
							'_value': '15px 8px',
						},
					},
				},
				'listStyle': {
					'_value': 'none',
				},
				'margin': {
					'bottom': '40px',
				},
				'padding': {
					'left': '0',
				},
			},
			'table': {
				'children': {
					'cell': {
						'border': {
							'bottom': {
								'_value': '1px solid rgb(199, 199, 199)',
							},
							'left': {
								'_value': 'none',
							},
							'right': {
								'_value': 'none',
							},
							'top': {
								'_value': 'none',
							},
						},
						'color': '#001928',
						'font': {
							'family': 'Heebo, Arial',
							'size': '16px',
							'style': 'normal',
							'weight': '400',
						},
						'lineHeight': '18px',
						'padding': {
							'_value': '15px 10px 15px 20px',
						},
						'selectors': {
							':first-child': {
								'breakpoints': [
									{
										'max': '767px',
										'style': {
											'margin': {
												'left': '5px !important',
											},
										},
									},
								],
								'padding': {
									'left': '20px',
								},
								'text': {
									'align': 'left',
								},
							},
							':last-child': {
								'breakpoints': [
									{
										'max': '767px',
										'style': {
											'padding': {
												'right': '5px !important',
											},
										},
									},
								],
								'padding': {
									'right': '16px',
								},
							},
						},
						'text': {
							'align': 'right',
						},
						'verticalAlign': 'middle',
					},
					'disclaimersWrapper': {
						'margin': {
							'top': '20px',
						},
					},
					'head': {
						'background': {
							'color': '#0079c1',
						},
						'color': '#fff',
					},
					'headCell': {
						'border': {
							'_value': 'none',
						},
						'breakpoints': [
							{
								'max': '767px',
								'min': '601px',
								'style': {
									'padding': {
										'_value': '15px 0 15px 5px !important',
									},
								},
							},
						],
						'font': {
							'family': '\'Heebo Bold\', Arial',
							'size': '16px',
							'weight': '700',
						},
						'lineHeight': '20px',
						'padding': {
							'_value': '15px 10px 15px 20px ',
						},
						'selectors': {
							':first-of-type': {
								'breakpoints': [
									{
										'min': '768px',
										'style': {
											'width': '132px',
										},
									},
									{
										'max': '767px',
										'style': {
											'padding': {
												'_value': '15px 0 15px 5px',
											},
											'width': '100px',
										},
									},
								],
								'text': {
									'align': 'left',
								},
							},
							':last-of-type': {
								'_raw': 'padding-right: 16px !important;',
								'breakpoints': [
									{
										'max': '767px',
										'style': {
											'padding': {
												'right': '5px !important',
											},
										},
									},
								],
							},
						},
						'text': {
							'align': 'right',
							'transform': 'initial',
						},
						'verticalAlign': 'middle',
					},
					'headRow': {
						'background': {
							'color': '#0075BE',
						},
					},
					'row': {
						'background': {
							'color': '#fff',
						},
						'height': '55px',
						'selectors': {
							':nth-child(2n+1)': {
								'background': {
									'color': '#F5F6F7',
								},
							},
						},
					},
					'wrapper': {
						'overrides': [
							{
								'selector': 'table',
								'style': {
									'tableLayout': 'fixed',
								},
							},
						],
					},
				},
				'margin': {
					'_value': '0',
				},
			},
		},
		'overview': {
			'disclaimer': {
				'children': {
					'text': {
						'color': '#212529',
						'font': {
							'family': 'Heebo, Arial',
							'size': '18px',
							'weight': '400',
						},
					},
				},
			},
		},
	},
};